import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionQuickAPICall extends APICallV3Post {
    _method = 'billing/subscription/quick';
}
